import { ComponentsVariants } from '@mui/material';

const variants: ComponentsVariants['MuiStep'] = [];

export default variants;
